/* @ngInject */
export default function PrivacyPolicyModalController(
  $uibModalInstance,
  currentInstitution,
) {
  const vm = this;
  vm.currentInstitution = currentInstitution;
}
